/* eslint-disable react-hooks/exhaustive-deps */
// Page Data Grup
// --------------------------------------------------------

import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import PageContainer from "../../../components/PageContainer";

// Redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";

// Page
import DataGroup from "./DataGroup";
import SemuaGroup from "./SemuaGroup";
import DetailGroup from "./DetailGroup";
import ProfilGroup from "./ProfilGroup";
import DetailPengguna from "./DetailPengguna";
import { setActiveStep } from "../../../store/actions/dataGroup";

const Page = () => {
  const dispatch = useDispatch();
  const [history, setHistory] = useState("");
  const { activeStep } = useSelector((state) => state.dataGroup, shallowEqual);

  useEffect(() => {
    return () => {
      dispatch(setActiveStep("page"));
    };
  }, []);

  return (
    <PageContainer>
      <Container>
        {activeStep === "page" && <DataGroup setHistory={setHistory} />}
        {activeStep === "all" && <SemuaGroup setHistory={setHistory} />}
        {activeStep === "detail" && <DetailGroup history={history} />}
        {activeStep === "grup" && <ProfilGroup history={history} />}
        {activeStep === "detailUser" && <DetailPengguna />}
      </Container>
    </PageContainer>
  );
};

const Container = styled("div")(() => ({
  width: "100%",
  height: "100%",
}));

export default Page;
